<template>
  <div class="card">
    <div class="sticky-discount"
         v-if="product.offer > 0">
      <span>{{ offerPercent }}%</span>
    </div>


    <router-link :to="{ name: 'Product', params: { name: product.raw_link } }">
      <img
          class="card-img-top"
          :alt="product.name"
          :src="product.thumbnail"
      />
    </router-link>


    <div class="card-body card-body-text">


      <router-link class="text-decoration-none text-dark"
                   :to="{ name: 'Product', params: { name: product.raw_link } }">
        <span class="font-weight-bold mt-1 d-block custom-font-size">{{ product.name.slice(0, 50) }}</span>
      </router-link>


      <m-single-product-price-wrapper :digital-shopping-cart-text="digitalShoppingCartBadge"
                                      :physical-shopping-cart-text="physicalShoppingCartBadge"
                                      :product="product">
        <template v-slot="{timing,quantity,addToCartFunction,buttonText}">

          <div class="col-lg-12" v-if="timing">
            <div class="col-lg-12" v-if="quantity">

              <m-product-price-100 class="text-dark" :product="product"/>
              <m-shopping-cart-controller-1 id="shopping-cart-controller" :product="product"/>

            </div>

            <div class="w-100 mt-3" v-else>

              <m-product-price-100 v-if="showPriceIfQuantityEmpty" class="text-dark" :product="product"/>
              <span class="text-center mt-3">موجودی محصول به پایان رسیده است.</span>

            </div>


          </div>
          <div class="w-100 mt-3" v-else>
            <m-product-price-100 v-if="showPriceIfTimeExpire" class="text-dark" :product="product"/>
            <span class="text-center mt-3">زمان سفارش این محصول به پایان رسیده است.</span>
          </div>

        </template>
      </m-single-product-price-wrapper>


    </div>

  </div>
</template>

<script>
import "swiper/css/swiper.css";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {mapGetters} from "vuex";
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {basketAddItem, addUnAuthItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {getProductPrice} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";


export default {
  name: "Card301",
  props: {
    product: {},
    digitalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    physicalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    showPriceIfQuantityEmpty: {
      default: true,
    },
    showPriceIfTimeExpire: {
      default: true,
    }
  },
  computed: {
    ...mapGetters({
      products: "Product/getProducts",
      categories: 'Category/getCategories'
    }),
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
    setQueryProduct() {
      return this.activeCategory != '' ? {category: this.activeCategory} : {};
    },
    offerPercent() {
      return Math.round((this.product.offer * 100) / this.product.price)
    }
  },
  methods: {
    formatNumber,
    isProductActive,
    basketAddItem,
    addUnAuthItem,
    getProductPrice,
    filterProducts(category) {
      if (category > 0) {
        this.activeCategory = category;
        this.$store.commit('Product/setFilters', {key: 'category', value: [category]})
        this.$store.dispatch("Product/setProducts", 1)
      } else {
        this.activeCategory = '';
        this.$store.commit('Product/setFilters', {key: 'category', value: []})
        this.$store.commit('Product/setFilters', {key: 'sort', value: ''})
        this.$store.dispatch("Product/setProducts", 1)
      }
    },
  },
}
</script>

<style>
#shopping-cart-controller .control-btn {
  padding: 0 5px 0;
}
</style>

<style scoped>


.card-button {
  border-radius: 15px;
  color: var(--light-info);
  font-size: 10px;
  font-weight: bold;
  margin-top: 10px;
}

.card-button:hover {
  border-color: white;
}

.card-body-text {
  text-align: center;
  direction: rtl;
}

.card-body {
  padding: 0px;
  padding-bottom: 5px;
}

.card {
  min-height: 370px;
  max-height: auto;
  border-radius: 10px;
  margin: 0px;
  margin-right: 10px;
}


.card .card-img-top {
  height: 200px;
  border-radius: 10px;
  object-fit: contain;
}

.prices {
  font-weight: bold;
  font-size: 17px;
}

.info {
  font-size: 11px;
  font-weight: bold;
}

.b-icon {
  padding: 0px;
  margin: 0px;
  font-size: 10px;
  color: var(--primary);
}

.sticky-discount {
  padding: 5px;
  position: absolute;
  margin: 10px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  background-color: var(--secondary);
  border-radius: 14px;
  border-bottom-right-radius: 0px;
  min-width: max-content;
}

.slider-btn > .b-icon {
  color: var(--primary);
  font-weight: bold;
}

.custom-icon-font-size {
  font-size: 20px;
}

.custom-font-size {
  font-size: 13px;
}

.add-shopping-cart-button {
  font-size: 20px !important;
  color: var(--light-white) !important;
}

#shopping-cart-controller {
  top: 80px;
  right: 0;
  position: absolute;
}


</style>